export const EPLEDGE_PLEDGE_DETAILS = "EPLEDGE_PLEDGE_DETAILS";
export const EPLEDGE_PLEDGE_ERROR = "EPLEDGE_PLEDGE_ERROR";
export const EPLEDGE_PLEDGE_HIDE_ERROR = "EPLEDGE_PLEDGE_HIDE_ERROR";
export const EPLEDGE_PLEDGE_START_LOADER = "EPLEDGE_PLEDGE_START_LOADER";
export const EPLEDGE_PLEDGE_STOP_LOADER = "EPLEDGE_PLEDGE_STOP_LOADER";
